import { useMemo, useContext, useEffect } from "react"
import { SeasonDatesFieldsProps } from "./interfaces/SeasonDatesFieldsProps"
import { monthOptions } from "./constants/monthOptionsConstant"
import { getDayOptions } from "./helpers/dayOptionsHelper"
import DropdownSelector from "~/components/ui/DropdownSelector/DropdownSelector"
import { AdminContext } from "~/contexts/AdminContext"
import { Controller } from "react-hook-form"

export const SeasonDatesFields = ({
  field_mm,
  field_dd,
  isMonthFirst,
  label,
  reactHookForm,
  hideNullValueOption
}: SeasonDatesFieldsProps) => {
  const { camp } = useContext(AdminContext)

  const { control, watch, setValue } = reactHookForm

  const watchedMonth = watch(field_mm)
  
  const dayOptions = useMemo(() => watchedMonth?.length ? getDayOptions(Number(watchedMonth)) : [], [watchedMonth])

  return (
    <div className="flex gap-2 flex-col">
      <label className="block font-semibold text-md text-gray-900 mb-0.5">{label}</label>
      <div className="flex gap-2">
        {isMonthFirst ? (
          <>
            <Controller
              name={field_mm}
              control={control}
              defaultValue={camp[field_mm]}
              render={({ field: { onChange, value } }) => (
                <DropdownSelector
                  dropdownClassNames="flex-1"
                  label="Month"
                  value={value}
                  onChange={(v) => {
                    setValue(field_dd, null ?? '1')
                    onChange(v)
                  }}
                  options={monthOptions}
                />
              )}
            />
            <Controller
              name={field_dd}
              control={control}
              defaultValue={camp[field_dd]}
              render={({ field: { onChange, value } }) => (
                <DropdownSelector
                  dropdownClassNames="flex-1"
                  label="Day"
                  disabled={!dayOptions?.length}
                  value={value}
                  onChange={onChange}
                  options={dayOptions}
                  hideNullValueOption
                />
              )}
            />
          </>
        ) : (
          <>
            <Controller
              name={field_dd}
              control={control}
              defaultValue={camp[field_dd]}
              render={({ field: { onChange, value } }) => (
                <DropdownSelector
                  dropdownClassNames="flex-1"
                  label="Day"
                  value={value}
                  onChange={onChange}
                  options={dayOptions}
                  disabled={!dayOptions?.length}
                  hideNullValueOption
                />
              )}
            />
            <Controller
              name={field_mm}
              control={control}
              defaultValue={camp[field_mm]}
              render={({ field: { onChange, value } }) => (
                <DropdownSelector
                  dropdownClassNames="flex-1"
                  label="Month"
                  value={value}
                  onChange={(v) => {
                    setValue(field_dd, null ?? '1')
                    onChange(v)
                  }}
                  options={monthOptions}
                />
              )}
            />
          </>
        )}
      </div>
    </div>
  )
}
